/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unsafe-storage */

import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

// @ts-ignore dependency missing types
import rootReducer from '../reducers';
// @ts-ignore dependency missing types
import LocalStoragePersistenceMiddleware from '../middleware/LocalStoragePersistenceMiddleware';
// @ts-ignore dependency missing types
import RavenErrorReportingMiddleware from '../middleware/RavenErrorReportingMiddleware';
// @ts-ignore dependency missing types
import CacheMiddleware from '../middleware/CacheMiddleware';
// @ts-ignore dependency missing types

export function configureStore(initialState) {
  return createStore(rootReducer, initialState, compose(applyMiddleware(thunk, CacheMiddleware, LocalStoragePersistenceMiddleware, RavenErrorReportingMiddleware), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f));
}